import { CommonLink } from "@/common/components";
import Routes from "@/routes/RouteComponent";
import { useEffect, useRef, useState } from "react";

const Titlebar = ({
  layout = "",
  wrapperClassName = "",
  showChangeProductManufacturer = true,
  showLogout = true,
  accessorDetails,
  productSponsorName,
}) => {
  const leftRef = useRef(null);
  const [isCustomInvisible, setIsCustomInvisible] = useState(false);
  useEffect(() => {
    const el = leftRef.current;
    setIsCustomInvisible(el ? el.classList.contains("customInvisible") : false);
  }, []); // run on mount; add deps if class may change via props
  return (
    <section className={`titlebar ${wrapperClassName}`} id="titlebar">
      <header className="container pt-2 d-flex justify-content-between w-100 align-items-center ">
        <div
          ref={leftRef}
          className={`${layout === "closableLayout" ? "customInvisible" : ""}`}
        >
          {accessorDetails?.customUserId} | {productSponsorName}
        </div>

        <div
          className={`d-flex ${
            layout === "closableLayout"
              ? "justify-content-between justify-content-md-end"
              : "justify-content-end"
          } ${isCustomInvisible ? "w-100" : ""}`}
        >
          {showChangeProductManufacturer && (
            <CommonLink
              path={Routes.dashboard.path}
              text="Change Product Manufacturer"
              wrapperClassName={`${
                isCustomInvisible
                  ? "customPostionAbsClassForNav"
                  : "me-3 d-flex justify-content-start"
              } `}
            />
          )}

          {showLogout && (
            <CommonLink
              path={Routes.logout.path}
              wrapperClassName={`${
                isCustomInvisible ? "ms-3 justify-content-end" : ""
              } ${showChangeProductManufacturer ? "" : "w-100"} d-flex logout`}
              text="Logout"
            />
          )}
        </div>
      </header>
    </section>
  );
};

export default Titlebar;
